import styles from "./Overlay.module.css";

const Overlay = (props) => {
  let style = "";
  if (props.overlayState === "EXIT") {
    style = styles["exit"];
  } else if (props.overlayState === "ENTER") {
    style = styles["enter"];
  }

  return props.overlayState !== "NONE" && <div className={style}></div>;
};

export default Overlay;
